import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { SegmentBoardEvent, segmentTrackAction } from '../../../../../../../../../middlewares/segment';

export const onPeriodSelectOpen = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
    ) => {
        dispatch(segmentTrackAction(SegmentBoardEvent.EMAIL_NOTIFICATIONS_FREQUENCY))
    };
    return action;
};
